import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const TableSearch = ({ onSearch, placeholder = "", defaultValue }) => {
  return (
    <div className="table__search--container">
      <input type="text" onChange={(event) => {
        if (onSearch) onSearch(event.target.value);
      }} placeholder={placeholder} defaultValue={defaultValue} />
      <div className="table__search--icon">
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </div>
    </div>
  )
};

const Table = ({ noOfResults = 0, list = [], onSelect, title, onSearch, placeholder = "", defaultSearchValue = "", filter }) => {
  return (
    <div className="table__container">
      {!!title && (
        <div className="table__title">
          {title}
        </div>
      )}
      <div className="table__configs">
        <div className="table__config--left">
          Showing: {noOfResults} Results
        </div>
        <div className="table__config--right">
          {filter && (
            <div className="select__input">
              <select onChange={(event) => {
                const { value } = event.target;

                filter.onChange(value);
              }}>
                {filter.options.map(item => <option value={item.value}>{item.label}</option>)}
              </select>
            </div>
          )}
          {onSearch && (
            <TableSearch onSearch={onSearch} placeholder={placeholder} defaultValue={defaultSearchValue} />
          )}
        </div>
      </div>

      <div className="table__content">
        <table>
          {list.map(tableRow => (
            <tr
              className={`table__row ${tableRow.isHeader && `table__row--header`}`}
              onClick={() => onSelect(tableRow.id)}
            >
              {tableRow.details.map(tableColumn => (
                <td
                  style={tableColumn.customStyle}
                  className={`table__column--item ${tableColumn.isHeader && `table__column--header`}`}
                >
                  {tableColumn.content}
                </td>
              ))}
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

export default Table;